var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFortuneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5l-1 1v1.06L8 2.5H6.586v1.414l.552.586H6.5l-1 1 1 1h7l1-1-1-1h-.638l.552-.586V2.5H12l-1 1.06V2.5l-1-1zm8 9v-3h-7v3h7zm-16-3h7v3H2v-3zm1 11v-6h6v6H3zm14 0h-6v-6h6v6z",
    fill: "#9A9CAC"
  })));
}

export default SvgFortuneIcon;